import { apiClient } from '../../../../helpers/apiHelperV2';
import { FETCH_CART_FAILURE, FETCH_CART_REQUEST, FETCH_CART_SUCCESS, RESET_PAYPAL_ONCLICK_SESSION, SET_CART, SET_PAYPAL_ONCLICK_SESSION } from '../../../actionTypes';
import { shouldFetch } from '../../../fetchStatus';
import { cartResponseSelector } from '../../../selectors/standort/session/cart';
import { categoryUrlSelector, standortUrlSelector } from '../../../selectors/url';
import { sessionIdSelector } from '../../../selectors/auth';
import { toast } from '../../../../helpers/toastHelper';
import _ from 'lodash';

export const fetchCartIfNeeded = () => {
    return async function (dispatch, getState) {
        const state = getState();
        const sessionId = sessionIdSelector(state);
        if (!sessionId) return console.warn('Cannot fetch cart server-side.');

        const standortUrl = standortUrlSelector(state);
        const cartResponse = cartResponseSelector(state);

        if (shouldFetch(cartResponse.status)) {
            dispatch({
                type: FETCH_CART_REQUEST,
                payload: { standortUrl, sessionId },
            });
            try {
                const res = await apiClient.get(`/api/v1/standorte/${standortUrl}/carts/${sessionId}`);
                const removedProducts = res.data.removedProducts;

                dispatch({
                    type: FETCH_CART_SUCCESS,
                    payload: { standortUrl, sessionId, cart: res.data.data },
                });

                if (removedProducts?.length > 0) {
                    toast({
                        message: 'Ein oder mehrere Artikel in Ihrem Warenkorb sind leider nicht mehr verfügbar. Bitte überprüfen Sie Ihren Warenkorb.',
                        status: 'danger',
                    });
                }
            } catch (error) {
                dispatch({
                    type: FETCH_CART_FAILURE,
                    payload: { standortUrl, sessionId, error },
                });
            }
        }
    };
};
export const addProduct = ({ product, quantity, buttonType, paypalOneClickSessionId }) => {
    return async function (dispatch, getState) {
        const state = getState();
        const standortUrl = standortUrlSelector(state);
        const categoryUrl = categoryUrlSelector(state);
        const sessionId = sessionIdSelector(state);
        if (!sessionId) return console.warn('Cannot add product server-side.');

        if(buttonType === "paypalOneClick"){
            try{
                product.bezeichnung = product.bezeichnung.replace(/<[^>]+>/gm, "")
                const { data } = await apiClient.put(`/api/v1/standorte/${standortUrl}/carts/${paypalOneClickSessionId}/addProduct`, {
                    product,
                    quantity,
                    categoryUrl,
                    buttonType
                });

                dispatch({
                    type: SET_PAYPAL_ONCLICK_SESSION,
                    payload: { paypalOneClickSessionId },
                });

                return data
            }catch (err) {
                toast({ err, message: err.response?.data?.data });
                dispatch({
                    type: RESET_PAYPAL_ONCLICK_SESSION,
                });
            }
            
        } else{
            try {
                product.bezeichnung = product.bezeichnung.replace(/<[^>]+>/gm, "")
                const { data } = await apiClient.put(`/api/v1/standorte/${standortUrl}/carts/${sessionId}/addProduct`, {
                    product,
                    quantity,
                    categoryUrl,
                    buttonType
                });

                /* toast({ message: 'Produkt wurde erfolgreich hinzugefügt', status: 'success' }); */

                dispatch({
                    type: SET_CART,
                    payload: { cart: data.data, standortUrl, sessionId },
                });
            } catch (err) {
                toast({ err, message: err.response?.data?.data });
            }
        }
        
    };
};
export const addService = ({ service }) => {
    return async function (dispatch, getState) {
        const state = getState();
        const standortUrl = standortUrlSelector(state);
        const sessionId = sessionIdSelector(state);
        if (!sessionId) return console.warn('Cannot add service server-side.');

        try {
            const { data } = await apiClient.put(`/api/v1/standorte/${standortUrl}/carts/${sessionId}/addService`, {
                service,
            });
            const cart = data.data;
            toast({ message: 'Service wurde erfolgreich hinzugefügt', status: 'success' });
            dispatch({
                type: SET_CART,
                payload: { cart: cart, standortUrl, sessionId },
            });
        } catch (err) {
            toast({ err });
        }
    };
};
export const addReifen = ({ reifen, quantity, buttonType, paypalOneClickSessionId }) => {
    return async function (dispatch, getState) {
        const state = getState();
        const standortUrl = standortUrlSelector(state);
        const sessionId = sessionIdSelector(state);
        if (!sessionId) return console.warn('Cannot add tire server-side.');

        if(buttonType === "paypalOneClick"){
            try{
                const { data } = await apiClient.put(`/api/v1/standorte/${standortUrl}/carts/${paypalOneClickSessionId}/addReifen`, {
                    reifen,
                    quantity,
                });
                //toast({ message: 'Die Reifen wurden erfolgreich hinzugefügt', status: 'success' });

                dispatch({
                    type: SET_PAYPAL_ONCLICK_SESSION,
                    payload: { paypalOneClickSessionId },
                });

                return data
            } catch (err) {
                toast({ err, message: err.response?.data?.data });
                dispatch({
                    type: RESET_PAYPAL_ONCLICK_SESSION,
                });
            }
            
            } else{
                try {
                    const { data } = await apiClient.put(`/api/v1/standorte/${standortUrl}/carts/${sessionId}/addReifen`, {
                        reifen,
                        quantity,
                    });
                    //toast({ message: 'Die Reifen wurden erfolgreich hinzugefügt', status: 'success' });
                    dispatch({
                        type: SET_CART,
                        payload: { cart: data.data, standortUrl, sessionId },
                    });
                } catch (err) {
                    toast({ err });
                }
            }
    };
};
export const addRim = ({ selectedRim, selectedVariant, quantity, carId }) => {
    return async function (dispatch, getState) {
        const state = getState();
        const standortUrl = standortUrlSelector(state);
        const sessionId = sessionIdSelector(state);
        if (!sessionId) return console.warn('Cannot add rim server-side.');

        try {
            const { data } = await apiClient.put(`/api/v1/standorte/${standortUrl}/carts/${sessionId}/addRim`, {
                selectedRim,
                selectedVariant,
                quantity,
                carId,
            });
            toast({ message: 'Die Felgen wurden erfolgreich hinzugefügt', status: 'success' });
            dispatch({
                type: SET_CART,
                payload: { cart: data.data, standortUrl, sessionId },
            });
        } catch (err) {
            toast({ err });
        }
    };
};
export const removeProduct = ({ product }) => {
    return async function (dispatch, getState) {
        const state = getState();
        const standortUrl = standortUrlSelector(state);
        const sessionId = sessionIdSelector(state);
        if (!sessionId) return console.warn('Cannot remove product server-side.');

        try {
            const { data } = await apiClient.put(`/api/v1/standorte/${standortUrl}/carts/${sessionId}/removeProduct`, {
                product,
            });
            toast({ message: 'Produkt wurde erfolgreich entfernt', status: 'success' });
            dispatch({
                type: SET_CART,
                payload: { cart: data.data, standortUrl, sessionId },
            });
        } catch (err) {
            toast({ err });
        }
    };
};
export const updateItem = ({ product }) => {
    return async function (dispatch, getState) {
        const state = getState();
        const standortUrl = standortUrlSelector(state);
        const sessionId = sessionIdSelector(state);
        if (!sessionId) return console.warn('Cannot update product server-side.');

        try {
            const { data } = await apiClient.put(`/api/v1/standorte/${standortUrl}/carts/${sessionId}/updateProduct`, {
                product,
            });
            toast({ message: 'Menge wurde erfolgreich angepasst', status: 'success' });
            dispatch({
                type: SET_CART,
                payload: { cart: data.data, standortUrl, sessionId },
            });
        } catch (err) {
            toast({ err });
        }
    };
};

// add coupon to cart
export const addCoupon = ({ couponCode }) => {
    return async function (dispatch, getState) {
        const state = getState();
        const standortUrl = standortUrlSelector(state);
        const sessionId = sessionIdSelector(state);
        if (!sessionId) return console.warn('Cannot update product server-side.');
        if (!couponCode) return;

        try {
            const {
                data: { cart, message },
            } = await apiClient.put(`/api/v1/standorte/${standortUrl}/carts/${sessionId}/coupons/${encodeURIComponent(couponCode)}`);
            
            toast({ message, status: 'success' });
            dispatch({
                type: SET_CART,
                payload: { cart, standortUrl, sessionId },
            });
        } catch (err) {
            toast({ err, message: err?.response?.data?.message });
        }
    };
};

export const deleteCoupon = () => {
    return async function (dispatch, getState) {
        const state = getState();
        const standortUrl = standortUrlSelector(state);
        const sessionId = sessionIdSelector(state);
        if (!sessionId) return console.warn('Cannot update product server-side.');

        try {
            const {
                data: { cart, message },
            } = await apiClient.delete(`/api/v1/standorte/${standortUrl}/carts/${sessionId}/coupons`);
            toast({ message, status: 'success' });
            dispatch({
                type: SET_CART,
                payload: { cart, standortUrl, sessionId },
            });
        } catch (err) {
            toast({ err });
        }
    };
};

export const deleteOneClickCart = ({ paypalOneClickSessionId }) => {
    return async function (dispatch, getState) {
        const state = getState();
        const standortUrl = standortUrlSelector(state);
        if (!paypalOneClickSessionId) return console.warn('Cannot remove product server-side.');
        try {
            await apiClient.delete(`/api/v1/standorte/${standortUrl}/carts/${paypalOneClickSessionId}/deleteOneClickCart`, {});            
        } catch (err) {
            toast({ err });
        }
    };
};


export const resetPaypalOneClick = () => {
    return async function (dispatch, getState) {
        dispatch({
            type: RESET_PAYPAL_ONCLICK_SESSION,
        });
    }
}

function isSoldOutArticle(article) {
    if (!article) {
        return true;
    }

    if (article.soldOut || article.active === false) {
        return true;
    }

    if (article.elementType === 'reifen' || article.neutralKey) {
        return article.stockkeeping && article.stock < 1 && article.stock !== null;
    }

    return (
        (article.isOwnArticle && article.stockkeeping && article.stock < 1 && article.stock !== null) ||
        (!article.isOwnArticle && !_.isNil(article.stock) && article.stock < 1)
    );
}

function getTireLookupIds(article) {
    return [...new Set(
        [article.slug, article.neutralKey, article.shownId, article.id, article._id]
            .filter(Boolean)
            .map(value => String(value))
    )];
}

function isSameCartArticle(cartArticle, article) {
    const cartArticleIds = [cartArticle.id, cartArticle.shownId, cartArticle.slug, cartArticle._id]
        .filter(Boolean)
        .map(value => String(value));
    const articleIds = [article.id, article.shownId, article.slug, article._id]
        .filter(Boolean)
        .map(value => String(value));

    return cartArticleIds.some(id => articleIds.includes(id));
}

async function removeUnavailableCartArticle({ standortUrl, cartSessionId, article, cart, products }) {
    try {
        const { data } = await apiClient.put(
            `/api/v1/standorte/${standortUrl}/carts/${cartSessionId}/removeProduct`,
            { product: article }
        );

        return data?.data || {
            ...cart,
            products: products.filter(cartArticle => !isSameCartArticle(cartArticle, article)),
        };
    } catch (err) {
        return {
            ...cart,
            products: products.filter(cartArticle => !isSameCartArticle(cartArticle, article)),
        };
    }
}

async function checkArticleAvailability({ standortUrl, article, categoryUrl }) {
    if (!article || article.elementType === 'service') {
        return true;
    }

    if (article.elementType === 'reifen' || categoryUrl === 'reifen') {
        const tireIds = getTireLookupIds(article);

        if (tireIds.length === 0) {
            return !isSoldOutArticle(article);
        }

        for (const tireId of tireIds) {
            try {
                const { data } = await apiClient.get(
                    `/api/v1/standorte/${standortUrl}/tires/${encodeURIComponent(tireId)}?availabilityCheck=1`
                );
                const tire = data?.tire;

                if (tire) {
                    return !isSoldOutArticle({ ...article, ...tire, elementType: 'reifen', isOwnArticle: tire.isOwnArticle ?? article.isOwnArticle });
                }
            } catch (err) {
                // try next lookup id
            }
        }

        return false;
    }

    const productId = article.id || article._id;
    
    if (!categoryUrl || !productId) {
        return !isSoldOutArticle(article);
    }
    try{
        const { data } = await apiClient.get(
            `/api/v1/standorte/${standortUrl}/categories/${encodeURIComponent(categoryUrl)}/products/${encodeURIComponent(productId)}`
        );
        const variant = data?.product?.varianten?.find(
            variantItem =>
                String(variantItem._id) === String(article._id) ||
                String(variantItem.id) === String(article.id) ||
                String(variantItem.id) === String(article.shownId)
        );
        if (data?.product?.active === false || data?.product?.soldOut || variant?.deleted) {
            return false;
        }

        return !isSoldOutArticle(variant);
    } catch(err){
        return false;
    }
}

export const validateCartBeforeCheckout = ({ sessionId: overrideSessionId, refreshCart = true } = {}) => {
    return async function (dispatch, getState) {
        const state = getState();
        const standortUrl = standortUrlSelector(state);
        const mainSessionId = sessionIdSelector(state);
        const cartSessionId = overrideSessionId || mainSessionId;
        if (!cartSessionId) return true;

        try {
            const previousProducts = cartResponseSelector(state)?.data?.products || [];
            const cartRes = await apiClient.get(`/api/v1/standorte/${standortUrl}/carts/${cartSessionId}`);
            const cart = cartRes.data.data;
            const removedProducts = cartRes.data.removedProducts;
            const products = cart?.products || [];
            if(products.length === 0 || removedProducts?.length > 0) {
                dispatch({
                    type: SET_CART,
                    payload: { cart, standortUrl, sessionId: mainSessionId },
                });
                if (removedProducts?.length > 0 || previousProducts.length > 0) {
                    toast({
                        message: 'Ein oder mehrere Artikel in Ihrem Warenkorb sind leider nicht mehr verfügbar. Bitte überprüfen Sie Ihren Warenkorb.',
                        status: 'danger',
                    });
                }
                return false
            }
            for (const article of products) {
                const categoryUrl = article.categoryUrl || (article.elementType === 'reifen' ? 'reifen' : null);
                const isAvailable = await checkArticleAvailability({ standortUrl, article, categoryUrl });

                if (!isAvailable) {
                    toast({
                        message: 'Ein oder mehrere Artikel in Ihrem Warenkorb sind leider nicht mehr verfügbar. Bitte überprüfen Sie Ihren Warenkorb.',
                        status: 'danger',
                    });

                    if (refreshCart && cartSessionId === mainSessionId) {
                        const updatedCart = await removeUnavailableCartArticle({
                            standortUrl,
                            cartSessionId,
                            article,
                            cart,
                            products,
                        });

                        dispatch({
                            type: SET_CART,
                            payload: { cart: updatedCart, standortUrl, sessionId: mainSessionId },
                        });
                    }
                    return false;
                }
            }

            if (refreshCart && cartSessionId === mainSessionId) {
                dispatch({
                    type: SET_CART,
                    payload: { cart, standortUrl, sessionId: mainSessionId },
                });
            }

            return true;
        } catch (err) {
            toast({ err, message: 'Beim Überprüfen des Warenkorbs ist ein Fehler aufgetreten.' });
            return false;
        }
    };
};

export const validateArticleBeforePaypalOneClick = ({ article, categoryUrl }) => {
    return async function (dispatch, getState) {
        const state = getState();
        const standortUrl = standortUrlSelector(state);

        if (!article) {
            return false;
        }

        try {

            const isAvailable = await checkArticleAvailability({ standortUrl, article, categoryUrl });
            if (!isAvailable) {
                toast({
                    message: 'Das gewählte Produkt ist aktuell nicht verfügbar.',
                    status: 'warning',
                });
                return false;
            }

            return true;
        } catch (err) {
            toast({ err, message: 'Beim Überprüfen der Verfügbarkeit ist ein Fehler aufgetreten.' });
            return false;
        }
    };
};
